export enum TagName {
  DEMO = "Demo",
  FIRST_DEMO = "First demo",
  SALES_EXPLORATION = "Sales exploration"
}

export enum TagColor {
  BLUE = "blue",
  TEAL = "teal",
  PURPLE = "purple"
}

const TAG_COLOR_MAP: Record<TagName, TagColor> = {
  [TagName.DEMO]: TagColor.BLUE,
  [TagName.FIRST_DEMO]: TagColor.TEAL,
  [TagName.SALES_EXPLORATION]: TagColor.PURPLE
};

const TAG_CSS_CLASS_MAP: Record<TagName, string> = {
  [TagName.DEMO]: "bg-surface-tags-blue border-border-tags-blue",
  [TagName.FIRST_DEMO]: "bg-surface-tags-teal border-border-tags-teal",
  [TagName.SALES_EXPLORATION]:
    "bg-surface-tags-purple border-border-tags-purple"
};

const COLOR_CSS_CLASS_MAP: Record<TagColor, string> = {
  [TagColor.BLUE]: "border-border-tags-blue bg-surface-tags-blue",
  [TagColor.PURPLE]: "border-border-tags-purple bg-surface-tags-purple",
  [TagColor.TEAL]: "border-border-tags-teal bg-surface-tags-teal"
};

export const getTagColorByName = (tagName: string): string => {
  return TAG_COLOR_MAP[tagName as TagName] || TagColor.BLUE;
};

export const getTagColorClassesByName = (tagName: string): string => {
  return (
    TAG_CSS_CLASS_MAP[tagName as TagName] || TAG_CSS_CLASS_MAP[TagName.DEMO]
  );
};

export const getTagColorClasses = (badgeColor: string): string => {
  return (
    COLOR_CSS_CLASS_MAP[badgeColor as TagColor] ||
    COLOR_CSS_CLASS_MAP[TagColor.BLUE]
  );
};
